// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ie-0";